//dropdowns
//-----------
//navigate with dropdown's opening button click
if (typeof $ === 'function') {
  $('html:not(.touchevents):not(.touch) .dropdown > .nav-link').on('click', function () {
    window.location.href = this.href;
  });
}

//do not close dropdown when clicked inside
if (typeof $ === 'function') {
  $('.dropdown-menu').on('click', function (e) {
    e.stopPropagation();
  });
}

//open active item in mobile navigation
$('#navbarCollapse').on('show.bs.collapse', function () {
  if (!$('html').is('.media-lg') && !$('html').is('.media-xl')) {
    $('#navigation .nav-item.dropdown.active:not(.show)').addClass('show')
      .find('.dropdown-toggle').attr('aria-expanded', 'true')
      .next('.dropdown-menu').addClass('show');
  }
});
